// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

export default {

    posturl( table, action )
    {
        var base = '/en/admin/geichi9AiG/crud';
        return `${base}?table=${table}&action=${action}`;
    },

    //× utility functions

    async GET( url, data = false )
    {
        return await this.AJAX( 'GET', url, data );
    },

    async POST( url, data )
    {
        return await this.AJAX( 'POST', url, data );
    },

    AJAX( type, url, data )
    {
        return new Promise( ( resolve ) => {

            let ajax_params = {
                type       : type,
                url        : url,
                contentType: 'application/json',
                cache      : false,
                success    : function( data, status, xhr )
                             {
                                // return
                                resolve({
                                    status: xhr.status,
                                    data  : data,
                                });
                            },
            };

            if ( data && ! $.isEmptyObject( data ) ){
                if ( type == 'GET' ){
                    ajax_params['data'] = data;
                }
                else if ( type == 'POST' ){
                    ajax_params['data'] = JSON.stringify( data, null, 4 );
                }
            }

            $.ajax( ajax_params ).fail( function( xhr, status ){

                // return
                resolve( {
                    status: xhr.status,
                    data  : null,
                });
            } );
        });
    },

}

